var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute"}},[_c('div',{staticClass:"SectionTable"},[_c('div',{staticStyle:{"opacity":"0.3"}},_vm._l((40),function(i){return _c('TemplateSectionRow',{key:i,attrs:{"emptyRow":""}})}),1)])])}
var staticRenderFns = []

export { render, staticRenderFns }